import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SendService {
    private apiBaseUrl = environment.apiBaseUrl;

    constructor(private httpClient: HttpClient) { }

    /**
     * @param methodToCall méthode à appeler
     */
    getData(methodToCall: any, number?: number): any {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiBaseUrl}/${methodToCall}/${number}`, { headers }).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (err) => {
                    reject(err);
                },
                complete: () => {
                    console.log('complete');
                }
            });
        });
    }

    getTransactionsData(methodToCall: any, number?: number): any {
        let url = '';
        if (number === undefined) {
            url = `${this.apiBaseUrl}/${methodToCall}`
        } else {
            url = `${this.apiBaseUrl}/transactions_new/${methodToCall}/${number}`
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return new Promise((resolve, reject) => {
            this.httpClient.get(url, { headers }).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (err) => {
                    reject(err);
                },
                complete: () => {
                    console.log('complete');
                }
            });
        });
    }

    getSpecificURL(url: string): any {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${url}`, { headers }).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (err) => {
                    reject(err);
                },
                complete: () => {
                    console.log('complete');
                }
            });
        });
    }

    get(url: string): any {
        // const headers = new HttpHeaders().set('Accept', '*/*').set(':authority', 'www.blockchain.com').set('Connection', 'keep-alive').set('Cache-Control', 'no-cache');
        // return new Promise((resolve, reject) => {
        //     this.httpClient.get(`${url}`, { headers }).subscribe({
        //         next: (data) => {
        //             resolve(data);
        //         },
        //         error: (err) => {
        //             reject(err);
        //         },
        //         complete: () => {
        //             console.log('complete');
        //         }
        //     });
        // });
    }
}   
